export * from './lib/responsive-menu.module';

export { AccredibleResponsiveMenuItem } from './lib/models/responsive-menu.model';
